var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sourceCode part"},[_c('h3',{staticClass:"tit"},[_vm._v("课程源码")]),_c('div',{staticClass:"inner"},[_c('ul',_vm._l((_vm.sourceCodeList),function(item,index){return _c('li',{domProps:{"textContent":_vm._s(item.codeName)}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }